<template>
  <body>
  <BaseList listSubtitulo="Solicitações de atendimento" :data="dados.results" :columns="columns" :globalFilterFields="columns"
            :totalRecords="dados.count" @update:pagination="loadDataLazy">
    <template v-slot:incluirCadastro>
      <button v-if="clienteLogado" id="id_incluir" class="btn btn-primary btn-sm font-bold modalIncluir"
              @click="abrirModal('cadastro')"
              title="Incluir novo registro.">
        <i class="fa fa-plus"></i> INCLUIR
      </button>

      <a style="margin-bottom: 10px" class="btn btn-success font-bold float-right" href="/arquivos/garantiascef.pdf"
         download="garantiascef.pdf">
        <i class="fa fa-file"></i> Documento de Garantia
      </a>
      <br>
    </template>

    <template #actions="{ data }">
      <div class="text-center">
        <button id="infoTab" class="btn btn-success font-bold text-white"
                @click="abrirModal('tabs', data.id, data.key)">
          <i class="fa fa-info"></i> INFORMAÇÕES
        </button>
      </div>
    </template>
  </BaseList>
  </body>
  <CadastrarChamadoCrm
      v-if="modalAtivo === 'cadastro'"
      :idModal="'cadastarModelo'"
      :clienteID="Number(clienteId)"
      @fechar="fecharModal"
      @atualizarLista="atualizarListaDados"
  />
  <TabsCrm
      v-if="modalAtivo === 'tabs'"
      :idModal="'TabsModal'"
      :itemKey="itemKeySelect"
      :itemSelect="itemSelect"
      @fechar="fecharModal"
      @statusAtualizado="atualizarStatusChamado"
  />
</template>

<script>
import BaseList from "@/components/base/BaseList.vue";
import CadastrarChamadoCrm from "./CadastrarChamadoCrm.vue";
import TabsCrm from "./TabsCrm.vue";
import {apiRequest} from "../../../public/js/utils/funcoes";
import {apiUrl} from "@/router/apiBackRoutes";


export default {
  name: "ListaCrm",
  components: {
    BaseList,
    CadastrarChamadoCrm,
    TabsCrm,
  },
  data() {
    return {
      dados: {
        results: [],
        count: 0,
      },
      pagination: {
        page: 1,
        page_size: 10,
      },
      erro: null,
      modalAtivo: null,
      itemSelect: null,
      itemKeySelect: null,
      clienteId: localStorage.getItem('crm_clienteId'),
      isStaff: localStorage.getItem('admin_isStaff'),
      clienteLogado: localStorage.getItem('crm_clienteLogado'),
      columns: [
        {field: 'id', header: 'ID', align: 'text-right',},
        {field: 'imovel_exibicao', header: 'IMÓVEL',},
        {field: 'data_cadastro', header: 'DATA CADASTRO', align: 'text-center',},
        {field: 'descricao', header: 'DESCRIÇÃO',},
        {field: 'status', header: 'STATUS', body: row => row.status || '', align: 'text-center',},
      ],
    };
  },
  methods: {
    atualizarListaDados(novoDado) {
      this.loadDataLazy({page: 1, page_size: this.pagination.page_size});
    },
    atualizarStatusChamado({id, status}) {
      const chamado = this.dados.results.find(c => c.id === id);
      if (chamado) {
        chamado.status = status;
      }
    },
    abrirModal(tipo, id = null, key = null) {
      this.modalAtivo = tipo;
      if (key) {
        this.itemKeySelect = key;
      }
      if (id) {
        this.itemSelect = id;
      }
    },
    fecharModal() {
      this.modalAtivo = null;
    },
    async loadDataLazy(paginationParams = this.pagination) {
      this.pagination = {
        page: paginationParams.page,
        page_size: paginationParams.page_size,
      };

      const params = {
        page: this.pagination.page,
        page_size: this.pagination.page_size,
      };

      if (paginationParams.search) {
        params.search = paginationParams.search;
      }

      const resultado = await apiRequest("GET", apiUrl.crm.createList, params);

      if (resultado.success) {
        this.dados.results = resultado.data.results || [];
        this.dados.count = resultado.data.count || 0;
      } else {
        this.$toastMessage("warn", "Atenção", "Erro ao carregar registro!");
        console.error("Erro ao carregar:", resultado.error);
      }
    },
    async getDados() {
      await this.loadDataLazy();
    },
  },
  mounted() {
    this.getDados().then(() => {
      const {abrir, id, key} = this.$route.query;

      if (abrir === 'tabs' && id && key) {
        this.abrirModal('tabs', Number(id), key);
      }
    });
  },
};
</script>
